var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.channel && _vm.channel.isLoaded)?_c('div',[(_vm.isSoccer)?_c('Register',{ref:"register"}):_c('Contact',{ref:"contact"}),_c('Loader')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }